import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';

const levels = {
    'elementary': 'Elementary',
    'high_school': 'High School',
    'honors': 'Honors',
    'university': 'University',
};

const QuizLink = ({ challenge, user }) => {
    const navigate = useNavigate();

    const [showChallenge, setShowChallenge] = useState(false);
    
    function goToQuizGameWithQuizId() {
        navigate('/quizgame#title', {
        state: {
            gradeQuiz: true,
            linkedQuizId: challenge.quiz.id,
        }   
        });
    }

    return (
        <div className="challenge">
        <Button className='quiz-btn small my-1' onClick={() => setShowChallenge(!showChallenge)}>
            {`${challenge.quiz.topic} | ${levels[challenge.quiz.level]} | ${challenge.quiz.number_questions} questions`} {showChallenge ? <FontAwesomeIcon icon={faChevronUp} className="ms-1"/> : <FontAwesomeIcon icon={faChevronDown} className="ms-1"/>}
        </Button>
        {showChallenge && 
        <Card className="mb-4 mx-3">
            <Card.Header className={`card-header-${challenge.quiz.level} px-2`}>{`${challenge.quiz.topic} - ${levels[challenge.quiz.level]}`}</Card.Header>
            <Card.Title className='text-center mt-2'>{`Challenger - ${challenge.challenger || ''}`}</Card.Title>
            <Card.Body className="d-flex flex-column justify-content-between p-0">
                <div className='d-flex flex-column align-items-center'>
                    <strong>Challenged:</strong> 
                    {challenge.challenged?.map((ch, idx) => (
                        <div key={`${challenge.id}-${idx}`}>
                        <p className="my-0" >{ch}</p>
                        </div>
                    ))}
                    <strong>Completed:</strong> 
                    {challenge.completed?.map((ch, idx) => (
                        <div key={`${challenge.id}-${idx}`}>
                        <p className="my-0">{ch}</p>
                        </div>
                    ))}
                </div>
                <div className="d-flex justify-content-center mt-2">
                    <Button 
                        className="green-silver-btn" 
                        disabled={user && !challenge.challenged.includes(user)}
                        onClick={goToQuizGameWithQuizId}>
                        Take this challenge
                    </Button>
                </div>
            </Card.Body>
        </Card>}
        </div>
    );
}

export default QuizLink